import dayjs from 'dayjs';

import {
  ABORTED,
  ADAPTIVE,
  CANCELLED,
  COMPLETED,
  EXPERIMENT,
  RUNNING,
  SCHEDULED,
  STARTED,
} from '@/constants';
import { SHORT_DATE } from '@/constants/dateTime';

export const SECONDS_PER_DAY = 86400;

interface ExperimentModel {
  name: string;
  id: string | number;
  state: string;
  start_time: number;
  end_time: number;
  experiment_template?: { domain: string };
}

interface ExperimentView {
  type: string;
  start_time: number;
  end_time: number;
  experiment_model?: ExperimentModel;
  adaptive_experiment_model?: ExperimentModel;
}

export const transformExperimentViews = (
  views: ExperimentView[],
  types = [EXPERIMENT, ADAPTIVE],
) => {
  return views?.flatMap((experiment) => {
    const type = experiment.type;
    if (!types.includes(type)) return [];

    const isAdaptive = type === ADAPTIVE;
    const experimentKey = isAdaptive
      ? 'adaptive_experiment_model'
      : 'experiment_model';
    const model = experiment[experimentKey];

    return [
      {
        key: model.name,
        id: isAdaptive ? String(model.id) : model.name,
        title: isAdaptive
          ? `${model?.experiment_template?.domain}.${model.name}`
          : model.name,
        start: isAdaptive
          ? dayjs.unix(model.start_time).format(SHORT_DATE)
          : dayjs.unix(experiment.start_time).format(SHORT_DATE),
        end: isAdaptive
          ? dayjs.unix(model.end_time + SECONDS_PER_DAY).format(SHORT_DATE)
          : dayjs
              .unix(experiment.end_time + SECONDS_PER_DAY)
              .format(SHORT_DATE),
        textColor: '#3D3D3D',
        color: '#3D3D3D',
        backgroundColor: isAdaptive ? '#F1EEFF' : '#EEF9F9',
        status: model.state,
        type,
      },
    ];
  });
};

export function getColorByStatus(status: string): string {
  switch (status) {
    case COMPLETED:
      return '#00B14F';
    case RUNNING:
    case STARTED:
      return '#136FD8';
    case SCHEDULED:
      return '#fa8c16';
    case ABORTED:
    case CANCELLED:
      return '#D42E1C';
    default:
      return '#3D3D3D';
  }
}
